import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { projectsFigure, projectsFigure2 } from '../../../assets/images';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup'; // CountUp importu
import './Projects.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Projects = () => {
  const { t } = useTranslation();
  const [hasStartedCounting, setHasStartedCounting] = useState(false); // Sayacın başlama durumu
  const observerRef = useRef(null); // Intersection observer için referans

  
    useEffect(() => {
      AOS.init({ duration: 2000, once: false }); 
    }, []);
  

  const newsItems = [
    { id: 1, project: 8, kvm: 500, date: "2016" },
    { id: 2, project: 12, kvm: 900, date: "2017" },
    { id: 3, project: 15, kvm: 1200, date: "2018" },
    { id: 4, project: 20, kvm: 700, date: "2019" },
    { id: 5, project: 17, kvm: 800, date: "2020" },
    { id: 6, project: 14, kvm: 1000, date: "2021" },
    { id: 7, project: 19, kvm: 900, date: "2022" },
    { id: 8, project: 28, kvm: 1200, date: "2023" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setHasStartedCounting(true); // Komponent görünür olursa sayacın başlamasına izin ver
        }
      },
      { threshold: 0.5 } // Komponentin %50'si görünür olduğunda tetiklenmesi için
    );

    if (observerRef.current) {
      observer.observe(observerRef.current); // Observer'ı ilgili elemente uygula
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current); // Bileşen temizlendiğinde observer'ı kaldır
      }
    };
  }, []);

  return (
    <div data-aos="fade-up" className='w-full items-center relative mt-[90px] md:mt-[118px] flex bg-[#FBFBFB]'>
      <div className='md:max-w-container w-full max-w-containerSm mx-auto'>
        <div className='flex flex-col justify-between relative'>
          <div className='flex justify-between items-center md:h-[110px] h-[150px]'>
            <div className='flex flex-col justify-center w-[847px]'>
              <p className='text-[24px] md:text-[32px] font-medium text-[#008A7F]'>{t("Həyata Keçirilənlər")}</p>
              <p className='text-[14px] md:text-[16px] text-[#1C1C1C] mt-4'>{t("Akondda layihələrin təsdiq edilmiş standartlara uyğun icra edilməsinə əmin olmaq üçün subpodratçılar və təchizatçılarla sıx əməkdaşlıq etməklə keyfiyyətli infrastrukturlar yaradır.")}</p>
            </div>
            <div className="absolute top-7 right-0 gap-2 hidden md:flex">
              <button className="swiper-button-prev-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
                <i className="fa-solid fa-angle-left w-4 text-[#767676] group-hover:text-[#01A396]"></i>
              </button>
              <button className="swiper-button-next-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
                <i className="fa-solid fa-angle-right w-4 text-[#767676] group-hover:text-[#01A396]"></i>
              </button>
            </div>
          </div>

          {/* Slider */}
          <div className='flex md:justify-between mt-[72px] gap-5'>
            <div className='md:w-[1063px] w-1/2' ref={observerRef}> {/* Intersection Observer için ref ekledik */}
              <Swiper
                spaceBetween={30}
                loop={true}
                pagination={{ clickable: true }}
                navigation={{
                  nextEl: '.swiper-button-next-custom',
                  prevEl: '.swiper-button-prev-custom',
                }}
                modules={[Pagination, Navigation]}
                breakpoints={{
                  480: { slidesPerView: 1 },
                  640: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 5 },
                }}
              >
                {newsItems.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="flex flex-col items-center relative w-[90%] md:w-[197px]">
                      {/* Tarih ve çizgi */}
                      <div className="flex items-center relative mb-[37px]">
                        <div className="bg-[#01A396] text-white text-xs px-5 py-2 rounded-[32px] z-10 text-[14px]">
                          {item.date}
                        </div>
                        <div className="absolute left-full top-1/2 transform -translate-y-1/2 h-[2px] w-[180px] bg-[#E5E5E5] z-0"></div>
                      </div>

                      {/* İçerik kutusu */}
                      <div className="relative w-[170px] h-[170px]">
                        <img className="md:w-[176px] object-cover w-full" src={projectsFigure} alt="Project" />
                        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center">
                          <p className="text-[#1C1C1C] font-medium text-lg">
                            {hasStartedCounting && <CountUp start={0} end={item.project} duration={4} />}
                          </p>
                          <p className="text-[#767676] text-[14px]">Layihə</p>
                          <p className="text-[#1C1C1C] font-medium text-lg mt-3">
                            {hasStartedCounting && <CountUp start={0} end={item.kvm} duration={4} />}
                          </p>
                          <p className="text-[#767676] text-[14px]">Kv.m</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className='md:w-[197px] w-1/2'>
              <div className="flex flex-col items-center relative w-[90%] md:w-[176px]">
                <div className="flex items-center relative mb-[37px]">
                  <div className="bg-[#01A396] text-white text-xs px-5 py-2 rounded-[32px] z-10 text-[14px]">
                    2025
                  </div>
                  <div className="absolute right-full top-1/2 transform -translate-y-1/2 h-[2px] w-[180px] bg-[#E5E5E5] z-0"></div>
                </div>

                <div className="relative w-[170px] h-[170px]">
                  <img className="w-full h-full object-cover" src={projectsFigure2} alt="Project" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center">
                    <p className="font-medium text-lg">
                      {hasStartedCounting && <CountUp start={0} end={40} duration={4} />}
                    </p>
                    <p className="text-[14px]">Layihə</p>
                    <p className="font-medium text-lg mt-3">
                      {hasStartedCounting && <CountUp start={0} end={1700} duration={4} />}
                    </p>
                    <p className="text-[14px]">Kv.m</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex md:hidden mx-auto mt-10 gap-3">
            <button className="swiper-button-prev-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-left w-4 text-[#767676] group-hover:text-[#01A396]"></i>
            </button>
            <button className="swiper-button-next-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-right w-4 text-[#767676] group-hover:text-[#01A396]"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
